import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useWorkspaceButtonStyles = makeStyles(({ palette, spacing }) =>
  createStyles({
    button: {
      borderRadius: 0,
      '&:hover': {
        backgroundColor: palette.primary.light,
      },
    },
    workspaceMenuItem: {
      width: 260,
    },
    editingMenuItem: {
      overflow: 'visible',
      // cant override focusVisible class, force no bg color when editing
      backgroundColor: 'transparent !important',
    },
    textField: {
      width: 'auto',
    },
    contextMenu: {
      padding: 0,
    },
    defaultIcon: {
      marginLeft: spacing(2),
    },
  })
);

export default useWorkspaceButtonStyles;
